import React, { useState } from "react";
import { MailOutlined, CalendarOutlined } from "@ant-design/icons";
import { Layout, Menu, Button } from "antd";
import SendEmailPage from "./pages/SendEmailPage/SendEmailPage";
import ReservationTicketsTable from "./pages/ReservationTable/ReservationTicketsTable";

const AdminDashboard = () => {
  const { Content, Sider } = Layout;
  const [menuKey, setMenuKey] = useState("1");

  const items = [
    {
      key: "1",
      icon: <MailOutlined />,
      label: "Повторен имейл",
    },
    {
      key: "2",
      icon: <CalendarOutlined />,
      label: "Лог таблица",
    },
  ];

  const logout = () => {
    window.location.reload();
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        defaultCollapsed={true}
        collapsedWidth="0"
        style={{ padding: "5px" }}
      >
        <div style={{ color: "#fff", textAlign: "center", marginTop: "10px" }}>
          <h3>Админ Панел</h3>
          <Button onClick={logout} style={{ marginTop: "20px" }}>
            Изход
          </Button>
        </div>
        <Menu
          style={{ marginTop: "20px" }}
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={items}
          onClick={(e) => setMenuKey(e.key)}
        />
      </Sider>
      <Layout>
        <Content
          style={{
            margin: "24px 16px 0",
          }}
        >
          {menuKey === "1" && <SendEmailPage />}
          {menuKey === "2" && <ReservationTicketsTable />}
        </Content>
      </Layout>
    </Layout>
  );
};
export default AdminDashboard;
